import { sub } from "date-fns";
import { zonedTimeToUtc } from "date-fns-tz";

export default class TimeInfo {
  localTime: Date = new Date();
  nepalTime: Date = new Date();

  constructor({
    localTime,
    timeStamp,
  }: {
    localTime?: Date;
    timeStamp?: number;
  }) {
    if (!localTime) {
      localTime = new Date();
    }
    if (timeStamp) {
      localTime = new Date(timeStamp);
    }
    let gmtTime: Date = zonedTimeToUtc(localTime, "Asia/Kathmandu");
    this.nepalTime = gmtTime;
    this.localTime = localTime;
  }

  isNepalTime(): boolean {
    let now: Date = new Date();
    return now.getTimezoneOffset() === -345;
  }
}


// returns nepal's 12:00 am timestamp for current day
export function getBaseTimeStamp({
  date,
  timestamp,
}: {
  date?: Date;
  timestamp?: number;
}): number | undefined {
  if (!date) {
    if (!timestamp) {
      return;
    }
    date = new Date(timestamp);
  }

  let timeInfo: TimeInfo = new TimeInfo({ localTime: date });
  let nepalTime: Date = timeInfo.nepalTime;
  let tt = sub(timeInfo.localTime, {
    hours: nepalTime.getHours(),
    minutes: nepalTime.getMinutes(),
    seconds: nepalTime.getSeconds(),
  }).getTime();
  tt = tt - nepalTime.getMilliseconds();
  return tt;
}